import moment from 'moment-timezone'

export const padHHMMSSNumber = (n: number): string => {
    return (n < 10 ? '0' : '') + n
}

export const secondsToSmartHHMMSS = (totalSeconds: number | null): string => {
    if (totalSeconds === null) return null
    const duration = moment.duration(totalSeconds, 'seconds')
    const hours = duration.hours()
    const minutes = duration.minutes()
    const seconds = duration.seconds()

    if (hours) {
        return `${hours}:${padHHMMSSNumber(minutes)}:${padHHMMSSNumber(seconds)}`
    } else {
        return `${minutes}:${padHHMMSSNumber(seconds)}`
    }
}

export const formattedDateMMDDYYYY = (dateString, separator = '/') => {
    const date = new Date(dateString)
    const year = date.getFullYear()
    const month = (1 + date.getMonth()).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')

    return `${year}${separator}${month}${separator}${day}`
}

export const isOfAge = (dateString) => {
    const age = getAge(dateString)
    return (age >= 18 && age < 100) || 'common:invalid_dob_under_18_over_100'
}

export const getAge = (dateString: string) => {
    return moment().diff(moment(dateString), 'years')
}